/**
 * Shape of a post category reference.
 */
export class PostCategory {
  constructor(data = {}) {
    this.id = typeof data.id === 'number' ? data.id : 0;
    this.title = data.title ?? '';
  }
}

/**
 * Represents the payload accepted by the post listing endpoints.
 */
export class GetPostsRequest {
  constructor(data = {}) {
    this.filter = data.filter ?? null;
    this.orderByType = data.orderByType ?? null;
    this.text = data.text ?? null;
    this.pageId = typeof data.pageId === 'number' ? data.pageId : 0;
    this.take = typeof data.take === 'number' ? data.take : 10;
    this.selectedGroup = Array.isArray(data.selectedGroup)
      ? data.selectedGroup
      : [];
    this.selectedTag = Array.isArray(data.selectedTag)
      ? data.selectedTag
      : [];
  }

  /**
   * Prepare a plain object suitable for axios.
   */
  toPayload() {
    const payload = {
      pageId: this.pageId,
      take: this.take,
    };

    if (this.filter) {
      payload.filter = this.filter;
    }
    if (this.text) {
      payload.text = this.text;
    }
    if (this.orderByType) {
      payload.orderByType = this.orderByType;
    }
    if (this.selectedGroup.length) {
      payload.selectedGroup = this.selectedGroup;
    }
    if (this.selectedTag.length) {
      payload.selectedTag = this.selectedTag;
    }

    return payload;
  }
}

/**
 * Detailed information for a news post/article.
 */
export class Post {
  constructor(data = {}) {
    this.pageId = typeof data.pageId === 'number' ? data.pageId : 0;
    this.langId = typeof data.langId === 'number' ? data.langId : 0;
    this.title = data.title ?? '';
    this.headline = data.headline ?? '';
    this.shortDescription = data.shortDescription ?? '';
    this.text = data.text ?? '';
    this.total = data.total ?? 12;
    this.source = data.source ?? '';
    this.writer = data.writer ?? '';
    this.createDate = data.createDate ?? null;
    this.personnelCreateDate = data.personnelCreateDate ?? null;
    this.updateDate = data.updateDate ?? null;
    this.shamsiCreateDate = data.shamsiCreateDate ?? '';
    this.priority = typeof data.priority === 'number' ? data.priority : null;
    this.commentCount = typeof data.commentCount === 'number' ? data.commentCount : 0;
    this.visitCount = typeof data.visitCount === 'number' ? data.visitCount : 0;
    this.visit = typeof data.visit === 'number' ? data.visit : null;
    this.isConfirm = Boolean(data.isConfirm);
    this.isGuestView = Boolean(data.isGuestView);
    this.userId = typeof data.userId === 'number' ? data.userId : null;
    this.imageName = data.imageName ?? '';
    this.smallImageName = data.smallImageName ?? '';
    this.videoUrl = data.videoUrl ?? '';
    this.tagsList = data.tagsList ?? '';
    this.categoryList = Array.isArray(data.categoryList)
      ? data.categoryList.map((item) => new PostCategory(item))
      : [];
  }
}

/**
 * Wraps the paged result of a post listing request.
 */
export class PostsResponse {
  constructor(data = {}) {
    this.totalCount = data.length > 0 ? (typeof data[0].total === 'number' ? data[0].total : 0) : 0;
    this.posts = Array.isArray(data.posts)
      ? data.posts.map((item) => new Post(item))
      : [];
  }
}
